import { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import ModalButtonOption from '../Modal/ModalButtonOption';
import AddIcon from '@mui/icons-material/Add';
import { getCurrentFunctionName } from '../../performanceModeManager';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class AddBlocModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: props.opened,
            values: this.props.value,
        }
    }

    shouldComponentUpdate(nextProps) {
        return this.props.value !== nextProps.value || this.props.opened !== nextProps.opened;
    }

    addBloc(option) {
        this.props.addBloc(option);
        this.close();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;
        modifiedState.modalOpenned = nextProps.opened;

        modifiedState.values = nextProps.value;
        return modifiedState;
    }

    close() {
        this.setState({ modalOpenned: false })
        this.props.closeModal();
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        return (
            <Dialog aria-labelledby="simple-dialog-title" fullScreen open={this.state.modalOpenned}
                onClose={this.close.bind(this)}>
                <AppBar className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            {this.props.label}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Toolbar/>
                <DialogContent>
                    <div className="offset-lg-4 col-lg-4 offset-md-3 col-md-6 col-sm-12 col-12 without-side-padding">
                        {this.props.options.map((o, i) => (
                            <ModalButtonOption key={i} value={o} name={o.name}
                                onClick={this.addBloc.bind(this)} icon={
                                    (<AddIcon className={classes.icon} />)
                                } />
                        ))}
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}

export default withStyles(styles)(AddBlocModal);
